module.exports = __webpack_public_path__ + "img/brodcast-kt.739f5bd6.jpg";